import * as React from 'react';
import { isStringAuthorizeHtml, unprotectAuthorizedHtml } from '../../helpers/protectStrings';

/** Copy from `@gandi/resource/redux` type. */
import { jsx as _jsx } from "react/jsx-runtime";
export function ErrorMessage({
  text
}) {
  if (typeof text === 'string' && isStringAuthorizeHtml(text)) {
    return /*#__PURE__*/_jsx("p", {
      className: "form-error"
      // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: unprotectAuthorizedHtml(text)
      }
    });
  }
  if (Array.isArray(text)) {
    // eslint-disable-next-line react/no-array-index-key
    return text.map((error, idx) => /*#__PURE__*/_jsx(ErrorMessage, {
      text: error
    }, idx));
  }
  if (!!text && typeof text === 'object') {
    if (/*#__PURE__*/React.isValidElement(text)) {
      // $FlowFixMe[incompatible-type] we already checked it's a React node
      return /*#__PURE__*/_jsx("p", {
        className: "form-error",
        children: text
      });
    }
    return Object.entries(text).map(([key, value]) => typeof value === 'string' ? /*#__PURE__*/_jsx(ErrorMessage, {
      text: `${key}: ${value}`
    }, key) :
    /*#__PURE__*/
    // $FlowFixMe[incompatible-type] we already checked it's not a React node
    _jsx(ErrorMessage, {
      text: value
    }, key));
  }
  return /*#__PURE__*/_jsx("p", {
    className: "form-error",
    children: text
  });
}